import React, { useMemo } from 'react'
import PrescriptionView from './PrescriptionView'
import { withAuth } from '~/utils/withAuth'
import useSWR from 'swr'
import { fetchPrescriptionsFromFb } from './PrescriptionService'

function PrescriptionLogged({ user, filials }) {
    const reqData = useMemo(() => {
        const { nome, idDependente, codeFilial: code } = user
        return {
            name: nome.trim(),
            idDependente,
            code,
        }
    }, [filials, user])

    const { data: prescriptions = [], isValidating } = useSWR(
        JSON.stringify(reqData),
        () => fetchPrescriptionsFromFb(filials, reqData),
        {
            revalidateOnFocus: false,
        }
    )

    return (
        <PrescriptionView
            showBreadcrumbs
            prescriptions={prescriptions}
            loading={isValidating}
        />
    )
}

export default withAuth(PrescriptionLogged)
